import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SAR } from 'dashboard/models/sar';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiEndpoint, ApiModel, ApiResponse } from 'lib/interfaces/api';

export const sarApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    getSarById: builder.query<ApiResponse<SAR>, string>({
      query: async (id) => {
        return SessionClientDashboard.getResource<SAR>(ApiEndpoint.SAR, id);
      },
      providesTags: (_result, _error, arg) => {
        return [{ type: ApiModel.SAR, id: arg }];
      },
    }),
    getSarsByIds: builder.query<ApiResponse<SAR>[], string[]>({
      query: async (ids) => {
        return Promise.all(
          ids.map((id) => SessionClientDashboard.getResource<SAR>(ApiEndpoint.SAR, id)),
        );
      },
      providesTags: (results = []) => {
        return results.map(({ data }) => {
          return { type: ApiModel.SAR, id: data.id };
        });
      },
    }),
  }),
});

// Hooks are autogenerated based on the defined endpoints
export const { useGetSarsByIdsQuery, useGetSarByIdQuery } = sarApi;
